import styled from 'styled-components'

export const ViewerContainer = styled.div<{
  $isDragging: boolean
  $hMobile: string
  $hDesktop: string
}>`
  position: relative;
  display: flex;
  width: 100%;
  /* Altura fixa = moldura estável: imagens/frames de tamanhos diferentes ficam
     centralizados (object-fit) sem empurrar o layout ao trocar frame/versão. */
  height: ${({ $hMobile }) => $hMobile};
  align-items: center;
  justify-content: center;
  overflow: hidden;
  outline: none;
  user-select: none;
  touch-action: none;
  cursor: ${({ $isDragging }) => ($isDragging ? 'grabbing' : 'grab')};

  @media (min-width: 768px) {
    height: ${({ $hDesktop }) => $hDesktop};
  }
`

export const FrameImage = styled.img<{
  $visible: boolean
}>`
  height: 100%;
  width: 100%;
  object-fit: contain;
  pointer-events: none;
  transition: opacity 150ms;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
`

export const Skeleton = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.05);
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`

export const Spinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -16px 0 0 -16px;
  width: 32px;
  height: 32px;
  border: 3px solid rgba(0, 0, 0, 0.12);
  border-top-color: rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  animation: spin360-rotate 0.8s linear infinite;

  @keyframes spin360-rotate {
    to { transform: rotate(360deg); }
  }
`

